"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATA_SLIDER_CONTENT = exports.DATA_SLIDER_ALL = exports.DATA_SLIDER_PROGRESS = exports.DATA_VIDEO_PLAY = exports.DATA_VIDEO_WRAP = exports.DATA_SCROLL_TO_TOP = exports.DATA_HEADER = exports.DATA_MODAL_FLAG = exports.DATA_MODAL_OVERLAY = exports.DATA_MODAL_CLOSE = exports.DATA_MODAL_OPEN = exports.DATA_MODAL = exports.DATA_LANGUAGE_SWITCH_SELECT = exports.DATA_COUNTRY_SWITCH_SELECT = exports.DATA_LANGUAGE_SWITCH = exports.DATA_FORM_ELEMENTS = exports.DATA_FLOATING_LABEL_FORM = exports.DATA_FORM = exports.DATA_AJAX_LOADER = exports.DATA_FILTER_HINT_WRAP = exports.DATA_INPUT_SEARCH_FIELD = exports.DATA_FILTER_CHECKBOX_WRAP = exports.DATA_FILTER_RESET = exports.DATA_FILTER_RESPONSE = exports.DATA_FILTER_CHANGE_RADIO_LABEL = exports.DATA_FILTER_CHANGE_RADIO = exports.DATA_FILTER_CHANGE_LABEL = exports.DATA_FILTER_CHANGE = exports.DATA_FILTER_URI = exports.DATA_FILTER = exports.DATA_FILE_INPUT_REMOVE = exports.DATA_FILE_INPUT_FILE_NAME = exports.DATA_FILE_INPUT_EMPTY = exports.DATA_FILE_INPUT_WRAPPER = exports.DATA_TOGGLE_APPLICATION_FILTER = exports.DATA_TOGGLE_PRODUCT_FILTER = exports.DATA_APPLICATION_FILTER = exports.DATA_FILTER_COLLAPSED = exports.DATA_DOP_ERROR = exports.DATA_DOP_ERROR_WRAPPER = exports.DATA_DOP_CODE_FORM = exports.DATA_DOP_RESPONSE = exports.DATA_DOP_SEARCH_PARENT_DIV = exports.DATA_COPY_TEXT = exports.DATA_COPY = exports.DATA_ACCORDION_OPEN = exports.DATA_MOBILE_MENU_BURGER = exports.DATA_MAIN_MENU_OVERLAY = exports.DATA_MAIN_MOBILE_MODAL = exports.DATA_MAIN_MOBILE_MENU_TOGGLER = void 0;
exports.DATA_POLL_HOVER_OPEN = exports.DATA_POLL_SUCCESS = exports.DATA_POLL_FORM = exports.DATA_POLL_BUTTON_END = exports.DATA_POLL_BUTTON_PREV = exports.DATA_POLL_BUTTON_NEXT = exports.DATA_POLL_PAGE = exports.DATA_POLL_AMOUNT = exports.DATA_POLL_BUTTON_START = exports.DATA_POLL_INTRO = exports.DATA_SOLR_AUTOCOMPLETE_TEMPLATE = exports.DATA_SOLR_AUTOCOMPLETE_SUGGESTIONS = exports.DATA_SOLR_AUTOCOMPLETE_WRAPPER = exports.DATA_SOLR_AUTOCOMPLETE_ITEM = exports.DATA_SOLR_AUTOCOMPLETE = exports.DATA_ZIPCODE = exports.DATA_ZIP_RESPONSE = exports.DATA_ZIP_URI = exports.DATA_ZIP_FORM = exports.DATA_REFERENCE_LIST_ITEM = exports.DATA_FILTER_LIST_REFERENCES = exports.DATA_APPLICATIONAREAS = exports.DATA_PRODUCT_FILTER = exports.DATA_DOWNLOAD_CONTENT = exports.DATA_DOWNLOAD_OPEN = exports.DATA_DOWNLOAD_WRAP = exports.DATA_SLIDER_REFERENCES = exports.DATA_SLIDER_TEASER = exports.DATA_SLIDER_BOXES = void 0;
// main menu
exports.DATA_MAIN_MOBILE_MENU_TOGGLER = 'data-main-mobile-menu-toggler';
exports.DATA_MAIN_MOBILE_MODAL = 'data-main-mobile-modal';
exports.DATA_MAIN_MENU_OVERLAY = 'data-main-menu-overlay';
exports.DATA_MOBILE_MENU_BURGER = 'data-mobile-menu-burger';
// accordion
exports.DATA_ACCORDION_OPEN = 'data-accordion-open';
// copy to clipboard
exports.DATA_COPY = 'data-copy-clipboard';
exports.DATA_COPY_TEXT = 'data-text-clipboard';
// dop
exports.DATA_DOP_SEARCH_PARENT_DIV = 'data-dop-search-parent-div';
exports.DATA_DOP_RESPONSE = 'data-dop-response';
exports.DATA_DOP_CODE_FORM = 'data-dop-code-form';
exports.DATA_DOP_ERROR_WRAPPER = 'data-dop-error-wrapper';
exports.DATA_DOP_ERROR = 'data-dop-error';
// faq filter
exports.DATA_FILTER_COLLAPSED = 'filter__collapsed';
exports.DATA_APPLICATION_FILTER = 'data-application-filter';
exports.DATA_TOGGLE_PRODUCT_FILTER = 'data-toggle-product-filter';
exports.DATA_TOGGLE_APPLICATION_FILTER = 'data-toggle-application-filter';
// file upload
exports.DATA_FILE_INPUT_WRAPPER = 'data-file-input-wrapper';
exports.DATA_FILE_INPUT_EMPTY = 'data-file-input-empty';
exports.DATA_FILE_INPUT_FILE_NAME = 'data-file-input-file-name';
exports.DATA_FILE_INPUT_REMOVE = 'data-file-input-remove';
// filter
exports.DATA_FILTER = 'data-filter';
exports.DATA_FILTER_URI = 'data-filter-uri';
exports.DATA_FILTER_CHANGE = 'data-filter-change';
exports.DATA_FILTER_CHANGE_LABEL = 'data-filter-change-label';
exports.DATA_FILTER_CHANGE_RADIO = 'data-filter-change-radio';
exports.DATA_FILTER_CHANGE_RADIO_LABEL = 'data-filter-change-radio-label';
exports.DATA_FILTER_RESPONSE = 'data-filter-response';
exports.DATA_FILTER_RESET = 'data-filter-reset';
exports.DATA_FILTER_CHECKBOX_WRAP = 'data-filter-checkbox-wrap';
exports.DATA_INPUT_SEARCH_FIELD = 'data-input-search-field';
exports.DATA_FILTER_HINT_WRAP = 'data-filter-hint-wrap';
exports.DATA_AJAX_LOADER = 'data-ajax-loader';
// form
exports.DATA_FORM = 'data-form';
// floating labels
exports.DATA_FLOATING_LABEL_FORM = 'data-floating-label-form';
exports.DATA_FORM_ELEMENTS = 'input,textarea,select';
// language switch
exports.DATA_LANGUAGE_SWITCH = 'data-language-switch';
exports.DATA_COUNTRY_SWITCH_SELECT = 'data-country-switch-select';
exports.DATA_LANGUAGE_SWITCH_SELECT = 'data-language-switch-select';
// modal
exports.DATA_MODAL = 'data-modal';
exports.DATA_MODAL_OPEN = 'data-modal-open';
exports.DATA_MODAL_CLOSE = 'data-modal-close';
exports.DATA_MODAL_OVERLAY = 'data-modal-overlay';
exports.DATA_MODAL_FLAG = 'data-modal-flag';
// scroll detector
exports.DATA_HEADER = 'data-header';
exports.DATA_SCROLL_TO_TOP = 'data-scroll-to-top';
// video player
exports.DATA_VIDEO_WRAP = 'data-video-wrap';
exports.DATA_VIDEO_PLAY = 'data-video-play';
// slider
exports.DATA_SLIDER_PROGRESS = 'data-slider-progress';
exports.DATA_SLIDER_ALL = 'data-slider-all';
exports.DATA_SLIDER_CONTENT = 'data-slider-content';
exports.DATA_SLIDER_BOXES = 'data-slider-boxes';
exports.DATA_SLIDER_TEASER = 'data-slider-teaser';
exports.DATA_SLIDER_REFERENCES = 'data-slider-references';
// product downloads
exports.DATA_DOWNLOAD_WRAP = 'data-download-wrap';
exports.DATA_DOWNLOAD_OPEN = 'data-download-open';
exports.DATA_DOWNLOAD_CONTENT = 'data-download-content';
// product filter
exports.DATA_PRODUCT_FILTER = 'data-product-filter';
exports.DATA_APPLICATIONAREAS = 'data-applicationAreas';
// references list
exports.DATA_FILTER_LIST_REFERENCES = 'data-filter-list-references';
exports.DATA_REFERENCE_LIST_ITEM = 'data-reference-list-item';
// zip search
exports.DATA_ZIP_FORM = 'data-zip-form';
exports.DATA_ZIP_URI = 'data-zip-uri';
exports.DATA_ZIP_RESPONSE = 'data-zip-response';
exports.DATA_ZIPCODE = 'data-zipcode';
// solr
exports.DATA_SOLR_AUTOCOMPLETE = 'data-solr-autocomplete';
exports.DATA_SOLR_AUTOCOMPLETE_ITEM = 'data-solr-autocomplete-item';
exports.DATA_SOLR_AUTOCOMPLETE_WRAPPER = 'data-solr-autocomplete-wrapper';
exports.DATA_SOLR_AUTOCOMPLETE_SUGGESTIONS = 'data-solr-autocomplete-suggestions';
exports.DATA_SOLR_AUTOCOMPLETE_TEMPLATE = 'data-solr-autocomplete-template';
// poll
exports.DATA_POLL_INTRO = 'data-poll-intro';
exports.DATA_POLL_BUTTON_START = 'data-poll-button-start';
exports.DATA_POLL_AMOUNT = 'data-poll-amount';
exports.DATA_POLL_PAGE = 'data-poll-page';
exports.DATA_POLL_BUTTON_NEXT = 'data-poll-button-next';
exports.DATA_POLL_BUTTON_PREV = 'data-poll-button-prev';
exports.DATA_POLL_BUTTON_END = 'data-poll-button-end';
exports.DATA_POLL_FORM = 'data-poll-form';
exports.DATA_POLL_SUCCESS = 'data-poll-success';
exports.DATA_POLL_HOVER_OPEN = 'data-poll-hover-open';
